import { IconPlusOutline18 as PlusIcon } from "nucleo-ui-outline-18"
import Balancer from "react-wrap-balancer"

import { Button } from "@productlane/ui"

import type { RouterOutputs } from "@/lib/api"
import { JoinWorkspaceItem } from "./join-workspaces-item"

interface IProps {
	allowedDomains: RouterOutputs["user"]["allowedDomains"]
	onCreateNew: () => void
}

export function JoinWorkspaceTab({ allowedDomains, onCreateNew }: IProps) {
	return (
		<div className="flex w-full flex-col items-center">
			<Balancer className="mb-8 text-center text-3xl font-bold tracking-tight">
				You have access to these workspaces
			</Balancer>

			<div className="w-full overflow-hidden rounded-xl border border-gray-200 dark:border-gray-800">
				<div className="max-h-80 divide-y divide-gray-200 overflow-y-auto dark:divide-gray-800">
					{allowedDomains?.map((allowedDomain) => (
						<JoinWorkspaceItem
							key={allowedDomain.id}
							allowedDomain={allowedDomain}
						/>
					))}
				</div>

				<div className="border-t border-gray-200 p-3 dark:border-gray-800">
					<Button
						variant="outline"
						isRounded
						size="default"
						onClick={onCreateNew}
						Icon={PlusIcon}
					>
						Create new workspace
					</Button>
				</div>
			</div>
		</div>
	)
}
